import { Pipe, PipeTransform, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';
import { normalizeCaseAndAccents } from '../utils/functions';
import moment from 'moment';
import { DateService } from '../services/date.service';
import levenshtein from 'js-levenshtein';

const MIN_FILTER_SIZE = 3

@Pipe({ name: 'tableFilter' })
export class TableFilterPipe implements PipeTransform {

    constructor(private dateService: DateService) {

    }

    transform(items, filterValue, columns) {

        if (_.size(filterValue) >= MIN_FILTER_SIZE) {

            // Quitamos todos los campos de los objetos que no se muestran en las columnas de la tabla
            let itemsFormat = this.valueToTransform(items, columns);

            // Devolvemos todos los objetos que tengan al menos una propiedad que haga match con lo introducido en el input
            let filteredItems = _.filter(itemsFormat, (i) => {
                return this.matchItem(i, filterValue)
            })

            // Recuperamos todos los campos eliminados para filtrar (Si no se hiciera el editar/borrar causaría error por la perdidad del ID)
            return _.intersectionWith(items, filteredItems, _.isMatch)
        } else {
            return items;
        }
    }

    valueToTransform(items, columns) {
        let tempColumn = [];

        columns.forEach(element => {
            tempColumn.push(!_.get(element, 'options.field') ? element.field : element.field + "." + element.options.field);
        });
        return _.map(items, function (object) {
            return _.pick(object, tempColumn);
        });

    }
    matchItem(item, filterValue) {
        return _.some(_.keysIn(item), (k) => {
            return this.matchValue(item[k], k, filterValue);
        })
    }



    matchValue(value, key, filterValue) {
        if (this.isSupportedValue(value)) {
            if (_.isBoolean(value)) {
                return this.matchBoolean(value, key, filterValue)
            } else if (moment.isDate(value)) {
                return this.matchDate(value, filterValue);
            } if (_.isObject(value)) {
                return this.matchItem(value, filterValue)
            } else {
                return this.match(value, filterValue)
            }
        } else {
            return false;
        }
    }

    isSupportedValue(value) {
        return value;
    }

    matchDate(value, filterValue) {
        return this.match(this.dateService.formatDate(value), filterValue);
    }

    matchBoolean(value, key, filterValue) {
        let splittedKey = _.split(key, '_');
        return _.some(splittedKey, (k) => {
            return levenshtein(normalizeCaseAndAccents(k), normalizeCaseAndAccents(filterValue)) <= 3;
        })
    }

    match(value1, value2) {
        return _.includes(normalizeCaseAndAccents(value1), normalizeCaseAndAccents(value2));
    }
}